<template>
  <div
    class="BQuestion"
    v-if="state.questionList && state.questionList?.length > 0"
  >
    <h2>{{ state.title }}</h2>

    <a-collapse
      v-model:activeKey="activeKey"
      :expand-icon-position="expandIconPosition"
    >
      <a-collapse-panel
        v-for="(item, i) in state.questionList"
        class=""
        :key="i"
        :header="item.data.content"
      >
        <div
          v-for="(item2, i2) in item.children"
          :key="i2"
          style="margin-top: 10px"
        >
          <!-- <p v-html="replaceTextWithDynamicLink(item2.data.content)" /> -->
          <p v-html="getText(item2.data.content)" />
        </div>
        <!-- <p
          v-for="(item2, i2) in item.children"
          :key="i2"
          style="margin-top: 10px"
        >
          {{ item2.data.content }}
        </p> -->
      </a-collapse-panel>
      <!-- <a-collapse-panel class="" key="2" header="This is panel header 2">
        <p>{{ text }}</p>
        <template #extra><setting-outlined @click="handleClick" /></template>
      </a-collapse-panel> -->
    </a-collapse>
  </div>
</template>

<script setup>
import { reactive } from "vue";
const route = useRoute();
logInfo("route.params", route.params);

// import expandIcon from "@/assets/imgs/close.png";
const state = reactive({
  title: "Let's Answer Your Questions",
  list: [
    {
      title:
        "This is a question This is a question This is a question This is a question?",
      text: `A dog is a type of domesticated animal.Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.`,
    },
    {
      title: "This is a question This is a questi 2222222?",
      text: `A dog is a type of domesticated animal.Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.`,
    },
  ],
  questionList: [],
});

const activeKey = ref([]);
const expandIconPosition = ref("end");

const handleClick = (event) => {
  event.stopPropagation();
};

const res = await useFetch(
  constants.BASE_URL + api.getQuestionInfo + `?goodsCode=${route.params.name}`,
  {
    method: "get",
  }
);
logInfo(
  `${constants.BASE_URL + api.getQuestionInfo} 商品详情问答返回数据`,
  res.data
);
state.questionList = res.data.value.data;

const replaceTextWithDynamicLink = (text) => {
  const linkTemplate = (url, matchedText) =>
    `<a class="sp" style="font-weight: 400;font-size: 14px;color: #0189be;line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="${url}">${matchedText}</a>`;

  // 根据需要添加更多的匹配条件
  switch (text) {
    case "support@greenvalleyintl.com":
      return linkTemplate("https://www.greenvalleyintl.com/support", text);
    case "https://www.greenvalleyintl.com/LiDAR360":
      return linkTemplate("https://www.greenvalleyintl.com/LiDAR360", text);
    case "https://www.greenvalleyintl.com/LiDAR360MLS":
      return linkTemplate("https://www.greenvalleyintl.com/LiDAR360MLS", text);
    case "https://www.greenvalleyintl.com/LiPowerline":
      return linkTemplate("https://www.greenvalleyintl.com/LiPowerline", text);
    default:
      return text; // 如果没有匹配，则返回原始文本
  }
};

const getText = (text) => {
  const replacements = [
    [
      "support@greenvalleyintl.com",
      `<a class="sp" style="font-weight: 400;font-size: 22px;color: #0189be;line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="https://www.greenvalleyintl.com/support" target="_blank">support@greenvalleyintl.com</a>`,
    ],
    [
      "https://www.youtube.com/@GreenValleyINTL",
      `<a class="sp" style="font-weight: 400;font-size: 22px;color: #0189be;line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="https://www.youtube.com/@GreenValleyINTL" target="_blank">https://www.youtube.com/@GreenValleyINTL</a>`,
    ],
    [
      "https://groups.google.com/g/gvi-lidar360",
      `<a class="sp" style="font-weight: 400;font-size: 22px;color: #0189be;line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="https://groups.google.com/g/gvi-lidar360" target="_blank">https://groups.google.com/g/gvi-lidar360</a>`,
    ],
    [
      "https://groups.google.com/g/otherseries",
      `<a class="sp" style="font-weight: 400;font-size: 22px;color: #0189be;line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="https://groups.google.com/g/otherseries" target="_blank">https://groups.google.com/g/otherseries</a>`,
    ],
    [
      "https://www.greenvalleyintl.com/LiDAR360MLS", // 需要特殊处理的文本
      `<a class="sp" style="font-weight: 400;font-size: 22px;color: #0189be;line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="https://www.greenvalleyintl.com/LiDAR360MLS" target="_blank">https://www.greenvalleyintl.com/LiDAR360MLS</a>`,
    ],
    [
      "https://www.greenvalleyintl.com/LiDAR360",
      `<a class="sp" style="font-weight: 400;font-size: 22px;color: #0189be;line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="https://www.greenvalleyintl.com/LiDAR360" target="_blank">https://www.greenvalleyintl.com/LiDAR360</a>`,
    ],
    [
      "https://www.greenvalleyintl.com/LiPowerline",
      `<a class="sp" style="font-weight: 400;font-size: 22px;color: #0189be;line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="https://www.greenvalleyintl.com/LiPowerline" target="_blank">https://www.greenvalleyintl.com/LiPowerline</a>`,
    ],
  ];

  for (const [search, replacement] of replacements) {
    if (text.indexOf(replacements[4][1]) > 0) continue;
    const regex = new RegExp(search, "g");
    text = text.replace(regex, replacement);
  }

  return text;
};
</script>

<style lang="less" scoped>
.BQuestion {
  h2 {
    .fcf(36,#B9B9BB,600);
    text-align: center;
    margin-top: 150px;
    margin-bottom: 30px;
  }

  :deep(.ant-collapse-header) {
    border: none;
    color: #fff !important;
    border-bottom: 1px solid #444;
    border-radius: 0 !important;
    padding: 20px 0 !important;

    .fcf(22,#B9B9BB) !important;
    .lh(30);
    svg {
      color: #818181;
    }
  }

  :deep(.ant-collapse-content) {
    border: none;
    color: #fff;
    border-bottom: 1px solid #444;
    border-radius: 0 !important;
    .fcf(22,#B9B9BB);
    .lh(30);
  }

  :deep(.ant-collapse-content-box) {
    border: none;
    color: #fff;
    background-color: @bgColor;
    .fcf(22,#B9B9BB);
    .lh(30);
  }

  :deep(.ant-collapse-item) {
    border: none;
    color: #fff;
  }
}

@media (max-width: 1024px) {
  .BQuestion {
    h2 {
      .fcf(30,#B9B9BB,600);
      text-align: center;
      margin-top: 50px;
      margin-bottom: 30px;
    }

    :deep(.ant-collapse-header) {
      .fcf(14,#B9B9BB) !important;
      .lh(23);
      padding: 16px 16px !important;
    }

    :deep(.ant-collapse-content) {
      .fcf(14,#B9B9BB);
      .lh(23);
    }

    :deep(.ant-collapse-content-box) {
      .fcf(14,#B9B9BB);
      .lh(23);
      div {
        p {
          a.sp {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
